import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";

export const AdminRefPrizes = () => {
  const [p, setP] = useState(null);
  useEffect(() => { api.get("/admin/ref-prizes").then((r) => setP(r.data.prizes)).catch(() => {}); }, []);
  if (!p) return null;
  const save = async () => {
    try { const { data } = await api.put("/admin/ref-prizes", { prizes: p.map((x) => Number(x) || 0) }); setP(data.prizes); toast.success("Prizes saved"); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="flex flex-wrap items-end gap-3 rounded-2xl border border-[#D2E0D8] bg-white p-4" data-testid="admin-ref-prizes">
      <div className="w-full"><p className="font-bold text-[#0D3B2B]">Monthly top-inviter prizes (Green Points)</p>
        <p className="text-xs text-[#7B968B]">Added automatically to the top 3 inviters when a month ends. Counts friends who completed their first pickup that month.</p></div>
      {p.map((v, i) => (
        <label key={i} className="text-xs font-semibold text-[#4A6358]">#{i + 1}
          <Input type="number" min="0" value={v} onChange={(e) => setP(p.map((x, j) => (j === i ? e.target.value : x)))} className="mt-1 h-9 w-28" data-testid={`ref-prize-${i + 1}`} /></label>
      ))}
      <button onClick={save} className="h-9 rounded-lg bg-[#0D3B2B] px-4 text-sm font-bold text-white" data-testid="ref-prizes-save-btn">Save</button>
    </div>
  );
};
